import { styled } from '@mui/material';

const COLOR_PRIMARY = '#606dbc';
const COLOR_SECONDARY = '#465298';

export const Layout = styled('div')`
  display: flex;
  height: inherit;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #444;

  background: repeating-linear-gradient(
    135deg,
    ${COLOR_PRIMARY},
    ${COLOR_PRIMARY} 25px,
    ${COLOR_SECONDARY} 25px,
    ${COLOR_SECONDARY} 50px
  );
`;
